import { Button, H6, Stack, Row, Col, Container } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { StyledErrorMessage, StyledCTAText, ErrorPageWrapper } from './ErrorPage.styles';

const SUPPORT_EMAIL = 'support@workramp.com';
const SUPPORTED_STATUSES = [401, 403, 404, 500];

interface StatusErrorPageProps {
  status: number;
  title?: undefined;
  message?: undefined;
  imgSrc?: undefined;
}

interface ErrorPageProps {
  status?: undefined;
  title: string;
  message?: string;
  imgSrc?: string;
}

export function ErrorPage({
  status,
  title: customTitle,
  message: customMessage,
  imgSrc: customImgSrc = '/images/error_warning.svg',
}: ErrorPageProps | StatusErrorPageProps) {
  const CTA_TEXT = I18n.t(`js.admin.errors.cta_text`);

  let title = customTitle;
  let message = customMessage;
  let imgSrc = customImgSrc;

  if (typeof status === 'number') {
    let normalizedStatus = status;
    if (!SUPPORTED_STATUSES.includes(status)) {
      normalizedStatus = 500;
    }

    title = I18n.t(`js.admin.errors.${normalizedStatus}.title`);
    message = I18n.t(`js.admin.errors.${normalizedStatus}.message`);
    imgSrc = normalizedStatus === 404 ? '/images/error_help.svg' : '/images/error_warning.svg';
  }

  return (
    <ErrorPageWrapper>
      <Container>
        <Row>
          <Col>
            <Stack size={8}>
              <img src={imgSrc} alt="WorkRamp logo" width="48" height="48" />

              <Stack size={4}>
                <H6 weight="semibold">{title}</H6>
                <Stack size={2}>
                  <StyledErrorMessage size={1}>{message}</StyledErrorMessage>
                  <StyledErrorMessage size={1}>
                    {CTA_TEXT} <StyledCTAText href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</StyledCTAText>?
                  </StyledErrorMessage>
                </Stack>
              </Stack>

              <Button color="secondary" variant="outline" onPress={() => window.history.back()}>
                Go back
              </Button>
            </Stack>
          </Col>
        </Row>
      </Container>
    </ErrorPageWrapper>
  );
}
